import * as React from 'react';

import { translate } from '~l10n/client';

import { CopyResettableLink } from '~teacher/components/CopyResettableLink';
import { useRoomDetail } from '~teacher/hook/room/useRoomDetail';

interface Props {
  roomId: number;
  showConfirmReset: () => void;
}
export function ShareRoomLink({ roomId, showConfirmReset }: Props) {
  const roomDetailQuery = useRoomDetail({ roomId: roomId });
  const shareUrl = roomDetailQuery.data?.url;

  return (
    <CopyResettableLink
      isCopyEnabled={true}
      link={shareUrl}
      resetLinkDisabled={false}
      handleResetLink={showConfirmReset}
      linkTextboxLabel={translate('Room invite link')}
      resetLinkLabel={translate('Reset room invite link')}
    />
  );
}
